// hooks
import useResponsive from "../../hooks/useResponsive";
// @mui
import {
  Card,
  Stack,
  Typography,
} from "@mui/material";
// components
import Iconify from '../../components/Iconify';

export default function DIOReviewLink() {
  const mdUp = useResponsive("up", "md");

  return (
    <Card
      sx={{
        mt: mdUp ? 0 : 3,
        width: 1,
        height: mdUp ? "242px" : 1,
        borderRadius: 1.5,
        border: 1,
        borderColor: "rgba(145, 158, 171, 0.24)",
        boxShadow: "none",
        bgcolor: "rgba(252, 252, 252, 1)",
        "&:hover": {
          cursor: "pointer",
          bgcolor: "rgba(145, 158, 171, 0.08)",
        },
      }}
      onClick={() => window.open("https://blog.dio.so/category/%EA%B8%B0%EC%97%85-%EA%B3%A0%EA%B0%9D-%ED%9B%84%EA%B8%B0", "_blank", "noopener, noreferrer")}
    >
      <Stack
        direction={mdUp ? "row" : "column"}
        spacing={2}
        alignItems={mdUp ? "flex-end" : "flex-start"}
        justifyContent="space-between"
        sx={{
          height: 1,
          backgroundImage: "url(https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/dio-biz-review-compass-2x.png)",
          backgroundPositionX: "right",
          backgroundPositionY: mdUp ? "top" : "bottom",
          backgroundRepeat: "no-repeat",
          backgroundSize: mdUp ? "auto 60%" : "auto 80%",
          minHeight: "180px",
        }}
      >
        <Stack
          spacing={.5}
          sx={{ p: 3, pb: mdUp ? 3 : 0, backgroundColor: "inherit", borderRadius: 2, boxShadow: "none" }}
        >
          <Typography variant="subtitle2">
            DIO 기업 고객 후기
          </Typography>
          <Stack direction="row" spacing={.5} alignItems="center">
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              자세히 보기
            </Typography>
            <Iconify
              icon={'ic:chevron-right'}
              sx={{
                color: "text.secondary",
                width: 18,
                height: 18,
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
